import React, { forwardRef } from "react";
import { Toast, Icon } from "@gusarov-studio/rubik-ui";

interface DeleteResourceToastContainerProps {
  onOpenChange: (open: boolean) => void;
  title: string;
  resourceId: string;
  undoAltText?: string;
  onUndo?: () => void;
}

const DeleteResourceToastContainer = forwardRef<
  React.ComponentRef<typeof Toast.Root>,
  DeleteResourceToastContainerProps
>(({ title = "Resource moved to trash", onOpenChange, onUndo }, ref) => {
  "use memo";
  return (
    <Toast.Root
      ref={ref}
      onOpenChange={onOpenChange}
      closable
      duration={3000}
      variant="black"
    >
      <Toast.Icon>
        <Icon
          glyph="trash-02"
          size="20"
        />
      </Toast.Icon>
      <Toast.Title>{title}</Toast.Title>
      {onUndo && (
        <Toast.Action
          altText="Undo"
          onClick={onUndo}
        >
          Undo
        </Toast.Action>
      )}
    </Toast.Root>
  );
});

DeleteResourceToastContainer.displayName = "DeleteResourceToastContainer";

export { DeleteResourceToastContainer };
